import OrderAnalytics from './OrderAnalytics.vue';
import ProductAnalytics from './ProductAnalytics.vue';
import InvoiceAnalytics from './InvoiceAnalytics.vue';

export default {
    OrderAnalytics,
    ProductAnalytics,
    InvoiceAnalytics
}